import { useContext } from 'react';
import { WP_Checklist } from '../../model/checklist/checklist';
import { NewsView } from '../../model/models';
import { ChecklistService } from '../../services/ChecklistService';
import { AppContext } from '../../state/AppContextProvider';
import CheckList from '../checklist/CheckList';

interface NewsGridProps {
  news: NewsView[];
  baseUrl: string;
  cols: '1' | '2';
  checklist: WP_Checklist | null;
  itemRenderer: (news: NewsView, baseUrl: string, key: number) => JSX.Element;
}

const GRID_COLS = {
  '1': 'md:grid-cols-1 md:gap-1',
  '2': 'md:grid-cols-2 md:gap-10',
};

export const NewsGrid: React.FC<NewsGridProps> = ({
  news,
  baseUrl,
  cols,
  checklist,
  itemRenderer,
}) => {
  const { state } = useContext(AppContext);
  const checklist_entry = ChecklistService.getEntry(
    checklist?.id || 0,
    state.allChecklistsEntries
  );
  return (
    <ul className={`ion-list-news grid w-full gap-y-8 ${GRID_COLS[cols]}`}>
      {checklist !== null && checklist_entry && (
        <li>
          <CheckList
            redirectionDisplay={true}
            paddingBottom={false}
            alignTextLeft={true}
            checklist={checklist}
            checklist_entry={checklist_entry}
            heightFull={true}
          />
        </li>
      )}
      {news.map((item, index) => itemRenderer(item, baseUrl, index))}
    </ul>
  );
};
